import { Link } from 'react-router-dom'
// import '../Components/MovieDatabase/MovieDB.css';

function BackToHome() {
  
  const goBack = ()=> {
    {window.history.back()}
  }

  return (
   
    <div className="go-back text-center spacer">
    <button onClick={goBack} className="button button-outline">&larr; Go Back</button>   
    <Link to="/" className="button button-outline">&larr; Back to Home</Link>
    </div>
  )
}

export default BackToHome
